__turbopack_context__.v({
  "accent": "Button-module-scss-module__EtFxQG__accent",
  "big": "Button-module-scss-module__EtFxQG__big",
  "button": "Button-module-scss-module__EtFxQG__button",
  "content": "Button-module-scss-module__EtFxQG__content",
  "destructive": "Button-module-scss-module__EtFxQG__destructive",
  "is_disabled": "Button-module-scss-module__EtFxQG__is_disabled",
  "is_full_width": "Button-module-scss-module__EtFxQG__is_full_width",
  "is_loading": "Button-module-scss-module__EtFxQG__is_loading",
  "is_with_icons": "Button-module-scss-module__EtFxQG__is_with_icons",
  "loader": "Button-module-scss-module__EtFxQG__loader",
  "medium": "Button-module-scss-module__EtFxQG__medium",
  "primary": "Button-module-scss-module__EtFxQG__primary",
  "secondary": "Button-module-scss-module__EtFxQG__secondary",
  "small": "Button-module-scss-module__EtFxQG__small",
  "spinner": "Button-module-scss-module__EtFxQG__spinner",
  "text": "Button-module-scss-module__EtFxQG__text",
});
